/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Import_Settings_Event_Group_NameInputs */



/**
* | output |
* | --- |
* | "Event Group Name" |
*
* @param {Ai_Import_Settings_Event_Group_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ai_import_settings_event_group_name = /** @type {((inputs?: Ai_Import_Settings_Event_Group_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Import_Settings_Event_Group_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom du groupe d'événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisgruppenname")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome del gruppo di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Название группы событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre del grupo de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件组名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループ名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समूह का नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome do grupo de eventos")
	return /** @type {LocalizedString} */ ("Event Group Name")
});